export let transformEventState = (state: string | undefined): string =>
  state
    ?.split(' ')
    .map((w) => w.slice(0, 1).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ') ?? ''

export let normalizeUrl = (url: string): string => {
  let trimmed = url.trim()
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
}
